<div *ngIf="loading" style="margin-top: 64px;display: flex;justify-content: center;">
  <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
  </p-progressSpinner>
</div>

<div class="container-fluid" *ngIf="!loading">
  <div>
    <div class="row margin-top-8">
      <div class="header">
        {{editing ? ( 'bikeshop.rentals.affiliates.edit' | translate ) : ( 'bikeshop.rentals.affiliates.add' |
        translate )}}
      </div>
    </div>

    <div class="info-container content">
      <div class="row">
        <div class="col-md-12 label bold">{{ 'bikeshop.rentals.affiliates.affiliate_info' | translate }}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-4 label"
          [ngClass]="{'red bold': affiliate.affiliateName === undefined || affiliate.affiliateName.length === 0}">
          {{ 'bikeshop.rentals.affiliates.name' | translate }}:
        </div>
        <div class="col-md-8 value">
          <input type="text" pInputText placeholder="{{'bikeshop.rentals.affiliates.name_placeholder' | translate}}"
            [(ngModel)]="affiliate.affiliateName" />
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-4 label"
          [ngClass]="{'red bold': affiliate.contactPerson === undefined || affiliate.contactPerson.length === 0}">
          {{ 'bikeshop.rentals.affiliates.contact_person' | translate }}:
        </div>
        <div class="col-md-8 value">
          <input type="text" pInputText placeholder="{{'bikeshop.rentals.affiliates.contact_person' | translate}}"
            [(ngModel)]="affiliate.contactPerson" />
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-4 label"
          [ngClass]="{'red bold': affiliate.contactEmail === undefined || affiliate.contactEmail.length === 0}">
          {{ 'bikeshop.rentals.affiliates.contact_email' | translate }}:
        </div>
        <div class="col-md-8 value">
          <input type="text" pInputText placeholder="{{'bikeshop.rentals.affiliates.contact_email' | translate}}"
            [(ngModel)]="affiliate.contactEmail" />
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-4 label"
          [ngClass]="{'red bold': affiliate.contactNumber === undefined || affiliate.contactNumber.length === 0}">
          {{ 'bikeshop.rentals.affiliates.contact_phone_number' | translate }}:
        </div>
        <div class="col-md-4 value">
          <input type="text" pInputText placeholder="{{'bikeshop.rentals.affiliates.contact_phone_number' | translate}}"
            [(ngModel)]="affiliate.contactNumber" />
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-4 label">
          {{ 'bikeshop.rentals.affiliates.address' | translate }}:
        </div>
        <div class="col-md-8 value">
          <input type="text" pInputText placeholder="{{'bikeshop.rentals.affiliates.address' | translate}}"
            [(ngModel)]="affiliate.physicalAddress" />
        </div>
      </div>

    </div>

    <div class="info-container content">
      <div class="row">
        <div class="col-md-12 label bold">{{ 'bikeshop.rentals.affiliates.commission' | translate }}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-4 label">
          {{ 'bikeshop.rentals.affiliates.pay_commission' | translate }}:
        </div>
        <div class="col-md-1 value">
          <p-inputSwitch [(ngModel)]="affiliate.payCommission"></p-inputSwitch>
        </div>
      </div>

      <div class="row margin-top-8" *ngIf="affiliate.payCommission">
        <div class="col-md-4 label"
          [ngClass]="{'red bold': affiliate.commissionPercentage === undefined || affiliate.commissionPercentage.length === 0}">
          {{ 'bikeshop.rentals.affiliates.commission_percentage' | translate }}:
        </div>
        <div class="col-md-3 value">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon"><i>%</i></span>
            <input type="number" pInputText [(ngModel)]="affiliate.commissionPercentage" />
          </div>
        </div>
      </div>

      <!-- <div class="row margin-top-8" *ngIf="hasStripeConfigured">
        <div class="col-md-4 label">
          {{ 'bikeshop.rentals.affiliates.stripe_connected' | translate }}:
        </div>
        <div class="col-md-8 label">
          {{ 'general.yes' | translate }}
        </div>
      </div> -->



      <div class="row margin-top-8" *ngIf="affiliate.payCommission">
        <div class="col-md-4 label" [ngClass]="{'red': !affiliate.payoutCycle}">
          {{ "bikeshop.rentals.affiliates.payout_cycle" | translate }}:
        </div>
        <div class="col-md-8 radio-container">
          <!-- <p-radioButton name="payoutCycle" value="IMMEDIATE" [(ngModel)]="affiliate.payoutCycle"
            label="{{ 'bikeshop.rentals.affiliates.payout.immediate' | translate }}"></p-radioButton> -->
          <p-radioButton name="payoutCycle" value="WEEKLY" [(ngModel)]="affiliate.payoutCycle"
            label="{{ 'bikeshop.rentals.affiliates.payout.weekly' | translate }}"></p-radioButton>
          <p-radioButton name="payoutCycle" value="MONTHLY" [(ngModel)]="affiliate.payoutCycle"
            label="{{ 'bikeshop.rentals.affiliates.payout.monthly' | translate }}"></p-radioButton>
        </div>
      </div>
      <div class="row" *ngIf="affiliate.payCommission">
        <div class="col-md-4"></div>
        <div class="col-md-8 label"><small>{{ "bikeshop.rentals.affiliates.payout_cycle_info" | translate }}</small></div>
      </div>
    </div>

    <div class="info-container content">
      <div class="row">
        <div class="col-md-12 label bold">{{ 'general.notifications' | translate }}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-4 label">
          {{ 'bikeshop.shop_profile.send_notification_on_rental' | translate }}:
        </div>
        <div class="col-md-1 value">
          <p-inputSwitch [(ngModel)]="affiliate.sendNotificationOnRental"></p-inputSwitch>
        </div>
        <div class="col-md-7">
          <small>{{ 'bikeshop.shop_profile.send_notification_on_rental_info' | translate }}</small>
        </div>
      </div>
      <div class="row margin-top-8" *ngIf="affiliate.sendNotificationOnRental">
        <div class="col-md-4 label"
          [ngClass]="{'red bold': affiliate.rentalNotificationsAddresses === undefined || affiliate.rentalNotificationsAddresses === null || affiliate.rentalNotificationsAddresses.length === 0}">
          {{ 'bikeshop.shop_profile.rental_notification_recipients' | translate }}:
        </div>
        <div class="col-md-8 value">
          <input type="text" pInputText [(ngModel)]="affiliate.rentalNotificationsAddresses" />
        </div>
      </div>
      <div class="row" *ngIf="affiliate.sendNotificationOnRental">
        <div class="col-md-4"></div>
        <div class="col-md-8"><small>{{ 'bikeshop.shop_profile.rental_notification_recipients_info' | translate
            }}</small></div>
      </div>
    </div>

    <div class="info-container content" *ngIf="affiliate.id && dangerousURL">
      <div class="row">
        <div class="col-md-12 label bold">{{ 'bikeshop.shop_setup.card_headers.rentals_widget' | translate }}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-4">
          <button pButton class="p-button-raised full-width p-mini"
            label="{{'bikeshop.shop_ride_configuration.copy_link' | translate}}" (click)="copyLink()"></button>
        </div>
        <div class="col-md-4">

        </div>
        <div class="col-md-4">
          <button pButton class="p-button-raised full-width p-mini"
            label="{{'bikeshop.shop_ride_configuration.copy_iframe' | translate}}" (click)="copyiFrame()"></button>
        </div>
      </div>
    </div>



    <div class="info-container content">
      <div class="button-container">
        <div class="row margin-bottom-16" *ngIf="!isValid()">
          <div class="col-md-12">
            <div class="red bold" style="font-size: 16px; text-align: right;">{{
              'bikeshop.rentals.products.validation_message' | translate }}</div>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <div style="display: flex;">
            <div *ngIf="editing" style="margin-right: 20px;">
              <button *ngIf="!deleting" pButton label="{{'bikeshop.rentals.affiliates.delete' | translate}}"
                class="p-button-raised alternate" (click)="deleteAffiliate()" [disabled]="saving"
                style="width: 200px;"></button>
              <div *ngIf="deleting">
                <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
                </p-progressSpinner>
              </div>
            </div>
          </div>
          <button *ngIf="!saving" pButton (click)="saveAffiliate()" class="p-button-raised"
            label="{{'bikeshop.general.save' | translate}}" [disabled]="loading || deleting || saving || !isValid()"
            style="width: 200px;"></button>
          <div *ngIf="saving">
            <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s"></p-progressSpinner>
          </div>
        </div>
      </div>
    </div>


  </div>

  <p-toast position="top-center" styleClass="hubtiger-toast" key="link-copied"></p-toast>
  <p-confirmDialog key="add_edit_rental_affiliate"></p-confirmDialog>
